// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"47e8e9c7","306":"d63ddcac","360":"d63ddcac","382":"47e8e9c7"}[chunkId] + ".chunk.css";
};